import React, { Fragment, useState, useEffect } from 'react';

import { isV2LayoutEnabled } from '../../helpers/featureFlags/isV2LayoutEnabled';
import { LayoutV2 } from '../LayoutV2/LayoutV2';
import LeftNavbar from '../LeftNavbar/LeftNavbar';
import Navbar from '../Navbar/Navbar';

function Layout(props) {
  const [isProviderUser, setIsProviderUser] = useState(false);

  useEffect(() => {
    const currentUser = JSON.parse(sessionStorage.getItem('TEAM_TYPE'));

    if (currentUser === 'Provider') {
      setIsProviderUser(true);
    } else {
      setIsProviderUser(false);
    }
  }, []);

  return (
    <Fragment>
      <Navbar />
      <div className="mk2 content">
        {!isProviderUser && <LeftNavbar />}
        <div className="mk2 rightbar">{props.children}</div>
      </div>
    </Fragment>
  );
}

const LayoutVersion = isV2LayoutEnabled() ? LayoutV2 : Layout;

export default LayoutVersion;
